import * as React from 'react';

declare var I18n : {
  locale: string,
  t: (_:string, __?: any) => string,
  toCurrency:(_:number) => string
}


export type ExportFeedProps = {
  url:string
  onCopy: () => void
}

export const ExportFeed = (props:ExportFeedProps) => (
  <div className="Ical__export">
    <label className="Ical__export-label" htmlFor="export">
      {I18n.t("calendar_feeds.crud.export.label")}
    </label>
    <div className="Ical__export-inputs">
      <input
        className="Ical__export-input"
        type="text"
        value={props.url}
        readOnly
        id="feedexport"
      />
      <input
        className="btn btn--white"
        type="button"
        value={I18n.t("calendar_feeds.crud.export.button")}
        onClick={(e) => {
          e.preventDefault();
          const input:HTMLInputElement = document.getElementById("feedexport") as HTMLInputElement;
          input.select();
          document.execCommand('copy');
          props.onCopy();
        }}
      />
    </div>
  </div>
)
